/** Opening Balance — load a plant's existing stock from a SeedTrac sheet. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { OpeningPage } from "@/features/inventory/opening/opening-page";
import { useDeskFacility } from "@/features/warehouse/route-helpers";

export const Route = createFileRoute("/_app/inventory/opening")({
  beforeLoad: () => {
    if (!useAuth.getState().can("inventory.opening"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  return <OpeningPage facilityId={useDeskFacility()} />;
}
